import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/AquaStations/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/AquaStations/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/AquaStations/GetById`, payload),
    Add: (payload) => Repository.post(`/api/AquaStations/Add`, payload),
    Edit: (payload) => Repository.post(`/api/AquaStations/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/AquaStations/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/AquaStations/ChangeStatus`, payload),
    GetListExport: (payload) => Repository.post(`/api/AquaStations/GetListExport`, payload),
    ExportProduct: (payload) => Repository.post(`/api/AquaStations/ExportProduct`, payload),
    EditDeploy: (payload) => Repository.post(`/api/AquaStations/EditDeploy`, payload),
    DeleteDeploy: (payload) => Repository.post(`/api/AquaStations/DeleteDeploy`, payload),
}